// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { usePortal } from './use-portal';

/**
 * Renders its `children` into a DOM node outside the parent React tree using
 * `react-dom` `createPortal`, driven by {@link usePortal}.
 *
 * @remarks
 * Built with {@link defineComponent}: `useSetup` is {@link usePortal}, and the `View`
 * renders the returned `portal` node (or `null`). Props match {@link UsePortalProps}
 * (`container` + `children`).
 * @example
 *
 * ```tsx
 * const id = useId();
 * return (
 *   <>
 *     <div id={id} />
 *     <Portal container={id}>
 *       <Menu />
 *     </Portal>
 *   </>
 * );
 * ```
 */
export const Portal = defineComponent({
  displayName: 'Portal',
  useSetup: usePortal,
  View: ({ portal }) => portal,
});
